import React from "react";
import { graphql } from "react-apollo";
import axios from "axios";
import PropTypes from "prop-types";
import Gravatar from "react-gravatar";
// @material-ui/core components
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
import Avatar from "@material-ui/core/Avatar";
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// Custom components
import CustomInput from "Custom-component/CustomInput/CustomInput.jsx";
import LoaderButton from "../../../Custom-component/LoaderButton";
// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// styles
import RevokemodelStyle from "../../CustomStyles/RevokemodelStyle";
// Queries and mutation
import Blockemployee from "../../../Graphql/Mutation/BlockEmployee";
// File imports
import config from "../../../config";
// validation
import validation from "../../Validation/ProfileValidation.jsx";

function Transition(props) {
	return <Slide direction="down" {...props} />;
}

class EmployeeUnblock extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showunblockuser: true,
			alert: null,
			UnrevokeModal: true,
			isLoading: false,
			admin_unblockemployee_reason: "",
			admin_unblockemployee_reasonState: ""
		};
	}
	// modal close button onclick function
	handleClose = () => {
		this.setState({
			alert: null,
			admin_unblockemployee_reason: "",
			admin_unblockemployee_reasonState: "",
			admin_unblockemployee_reasonErrMsg: ""
		});
	};

	handleUnrevokeClose = modelname => {
		this.setState({ [modelname]: false });
		this.props.handleback("close", "close");
	};
	// onchange function for input fields
	change_employee_unblock(event, stateName, type) {
		switch (type) {
			case "textarea_employee_unblock":
				var reason_employee_validation = validation.verifyTextarea(
					event.target.value,
					stateName
				);
				if (!reason_employee_validation[stateName]) {
					this.setState({ [stateName + "State"]: "success" });
				} else {
					this.setState({
						[stateName + "State"]: "error",
						[stateName + "ErrMsg"]: reason_employee_validation[stateName]
					});
				}
				break;

			default:
				break;
		}
		this.setState({ [stateName]: event.target.value });
	}

	// validate the inputs on submit
	validate = () => {
		if (
			this.state.admin_unblockemployee_reason !== "" &&
			this.state.admin_unblockemployee_reasonState === "success"
		) {
			return false;
		} else {
			return true;
		}
	};

	// Function to Unrevoke user
	handleUnblockuser = async event => {
		const { blocked_employee_data } = this.props;
		this.setState({ isLoading: true });
		if (
			this.state.admin_unblockemployee_reason !== "" &&
			this.state.admin_unblockemployee_reasonState === "success"
		) {
			try {
				const Employee_unblock_payload = {
					employee_username: blocked_employee_data.username,
					profile_status: "Active",
					reason: this.state.admin_unblockemployee_reason
				};
				var headers = {
					Authorization: localStorage.getItem("accessToken"),
					"Content-Type": "application/json"
				};
				axios
					.post(config.Cognito.Employee_action, Employee_unblock_payload, {
						headers: headers
					})
					.then(response => {
						if (response.data.data !== null) {
							this.setState({ isLoading: false });
							this.props.handleback("Success", "User Unblocked Successfully");
						} else {
							this.setState({ isLoading: false });
							this.props.handleback(
								"Failed",
								"Failed to Unblock User.Please Try Again."
							);
						}
					})
					.catch(err => {
						this.setState({ isLoading: false });
						this.props.handleback(
							"Failed",
							"Failed to Unblock User.Please Try Again."
						);
					});
			} catch (e) {
				this.setState({ isLoading: false });
				this.props.handleback(
					"Failed",
					"Failed to Unblock User.Please Try Again."
				);
			}
		} else {
			this.setState({
				admin_unblockemployee_reasonState: "error",
				admin_unblockemployee_reasonErrMsg: "Reason is required"
			});
		}
	};
	render() {
		const {
			classes,
			blocked_employee_data,
			employee_data_profile
		} = this.props;

		return (
			<div className={classes.wrapper}>
				{this.state.showunblockuser ? (
					<Dialog
						classes={{
							root: classes.center + " " + classes.modalRoot,
							paper: classes.modal
						}}
						open={this.state.UnrevokeModal}
						TransitionComponent={Transition}
						keepMounted
						onClose={() => this.handleUnrevokeClose("UnrevokeModal")}
						aria-labelledby="notice-modal-slide-title"
						aria-describedby="notice-modal-slide-description"
					>
						<DialogTitle
							id="notice-modal-slide-title"
							disableTypography
							className={classes.modalHeader}
						>
							<Button
								justIcon
								className={classes.modalCloseButton}
								key="close"
								aria-label="Close"
								color="transparent"
								onClick={() => this.handleUnrevokeClose("UnrevokeModal")}
							>
								<Close className={classes.modalClose} />
							</Button>
							<h4 className={classes.boldheading}>Unblock User</h4>
						</DialogTitle>
						<DialogContent
							id="notice-modal-slide-description"
							className={classes.modalBody}
						>
							<GridContainer justify="center">
								<GridItem xs={6} sm={3} md={3}>
									<GridContainer justify="center">
										<Avatar className={classes.revokeuserAvatar}>
											{/* if employee upload the image */}
											{employee_data_profile.profile_image_hash &&
											this.props.employee_fileContent ? (
												<img
													src={this.props.employee_fileContent}
													className={classes.avatarImg}
													alt="..."
												/>
											) : (
												<a href="#pablo" onClick={e => e.preventDefault()}>
													<Gravatar
														email={employee_data_profile.email}
														default="mp"
														size={120}
													/>
												</a>
											)}
										</Avatar>

										{/* <Avatar className={classes.revokeuserAvatar}>
											<Gravatar
												email={blocked_employee_data.email}
												default="mp"
												size={120}
											/>
										</Avatar> */}
									</GridContainer>
								</GridItem>
							</GridContainer>
							<br />
							<br />
							<GridContainer justify="flex-start">
								<GridItem xs={6} sm={6} md={6}>
									<p className={classes.mainheading}>
										<b> Username</b>
									</p>
								</GridItem>

								<GridItem xs={6} sm={6} md={6}>
									<p> {blocked_employee_data.username}</p>{" "}
									{/* //!username only given as uniqueid */}
								</GridItem>
							</GridContainer>
							<GridContainer justify="flex-start">
								<GridItem xs={6} sm={6} md={6}>
									<p className={classes.mainheading}>
										<b> Employee Name</b>
									</p>
								</GridItem>

								<GridItem xs={6} sm={6} md={6}>
									<p> {blocked_employee_data.name}</p>
								</GridItem>
							</GridContainer>
							<GridContainer justify="center">
								<GridItem xs={12} sm={12} md={12}>
									<CustomInput
										success={
											this.state.admin_unblockemployee_reasonState === "success"
										}
										error={
											this.state.admin_unblockemployee_reasonState === "error"
										}
										labelText={<span>Reason to Unblock*</span>}
										id="Admin_Unblockuser_reason"
										formControlProps={{
											fullWidth: true
										}}
										helpText={
											this.state.admin_unblockemployee_reasonState === "error"
												? this.state.admin_unblockemployee_reasonErrMsg
												: null
										}
										inputProps={{
											multiline: true,
											rows: 2,
											onChange: event =>
												this.change_employee_unblock(
													event,
													"admin_unblockemployee_reason",
													"textarea_employee_unblock",
													3
												)
										}}
									/>
								</GridItem>
							</GridContainer>
							<p>Note: Unblock user with valid reason.</p>
						</DialogContent>
						<DialogActions
							className={classes.modalFooter + " " + classes.modalFooterCenter}
						>
							<LoaderButton
								id="unblock_button"
								type="submit"
								onClick={this.handleUnblockuser}
								disabled={this.validate()}
								color="info"
								round
								isLoading={this.state.isLoading}
								text="Unblock"
								loadingText="Processing..."
							/>
						</DialogActions>
					</Dialog>
				) : null}

				{this.state.alert}
			</div>
		);
	}
}

EmployeeUnblock.propTypes = {
	classes: PropTypes.object.isRequired
};

const EmployeeUnblockwithstyle = withStyles(RevokemodelStyle)(EmployeeUnblock);
export default graphql(Blockemployee)(EmployeeUnblockwithstyle);
